module.exports = __webpack_public_path__ + "img/orga.85a5007c.svg";